import {useState} from "react";

export const useModals = () => {
    const [modals, setModals] = useState([]);

    const openModal = (modalContent) => {
        setModals((prevModals) => [...prevModals, modalContent]);
    }

    const closeModal = () => {
        setModals((prevModals) => prevModals.slice(0, -1));
    }

    const currentModal = modals.length > 0 ? modals[modals.length - 1] : null;

    return {
        modals,
        openModal,
        closeModal,
        currentModal
    }
}